module.exports = __webpack_public_path__ + "static/media/arrow-left.91200a9b.svg";